var _defs, _g, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88.77499999999999px",
    height: "124.39999999999999px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "205.6125 12.800000000000004 88.77499999999999 124.39999999999999",
    style: {
      background: "rgba(0, 0, 0, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "editing-offset"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0%,0%,0%,0)",
    floodOpacity: 0.5,
    result: "c1"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(14.180098831985621%,90.54761904761904%,84.32200598656209%,0.434)",
    floodOpacity: 0.5,
    result: "c2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00adb5",
    floodOpacity: 0.5,
    result: "c3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c1",
    in2: "SourceAlpha",
    result: "text-c1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c2",
    in2: "SourceAlpha",
    result: "text-c2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c3",
    in2: "SourceAlpha",
    result: "text-c3"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "text-c1",
    dx: -10,
    dy: 0,
    result: "text1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "text-c2",
    dx: 10,
    dy: 0,
    result: "text2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "text-c3",
    dx: 0,
    dy: 0,
    result: "text3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "text1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "text2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "text3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-offset)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.96501648426056, 104.7650032043457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.63 7.28L5.44 7.28L5.44-33.28L11.59-33.28L11.59 7.28L11.59 7.28Q11.59 8.56 11.11 9.69L11.11 9.69L11.11 9.69Q10.63 10.81 9.80 11.64L9.80 11.64L9.80 11.64Q8.97 12.47 7.84 12.95L7.84 12.95L7.84 12.95Q6.72 13.44 5.44 13.44L5.44 13.44L0.63 13.44L0.63 7.28ZM5.13-39.69L5.13-46.09L11.91-46.09L11.91-39.69L5.13-39.69ZM20.22-27.13L20.22-33.28L28.34-33.28L28.34-43.53L34.50-43.53L34.50-33.28L45.44-33.28L45.44-27.13L34.50-27.13L34.50-6.16L45.44-6.16L45.44 0L34.50 0L34.50 0Q33.25 0 32.13-0.48L32.13-0.48L32.13-0.48Q31-0.97 30.16-1.80L30.16-1.80L30.16-1.80Q29.31-2.63 28.83-3.75L28.83-3.75L28.83-3.75Q28.34-4.88 28.34-6.16L28.34-6.16L28.34-27.13L20.22-27.13Z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text {\n  font-size: 64px;\n  font-family: Arial Black;\n  dominant-baseline: central;\n  text-anchor: middle;\n}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJt);
export default __webpack_public_path__ + "static/media/jt.0e10f8d9730ee8ba250c80e43ec94b97.svg";
export { ForwardRef as ReactComponent };